import { render, staticRenderFns } from "./PersonalQuota.vue?vue&type=template&id=53e1e6ac&scoped=true&"
import script from "./PersonalQuota.vue?vue&type=script&lang=js&"
export * from "./PersonalQuota.vue?vue&type=script&lang=js&"
import style0 from "./PersonalQuota.vue?vue&type=style&index=0&id=53e1e6ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1e6ac",
  null
  
)

export default component.exports